import { render, staticRenderFns } from "./SettlementmanagementList.vue?vue&type=template&id=21fcfea2&scoped=true"
import script from "./SettlementmanagementList.vue?vue&type=script&lang=js"
export * from "./SettlementmanagementList.vue?vue&type=script&lang=js"
import style0 from "./SettlementmanagementList.vue?vue&type=style&index=0&id=21fcfea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcfea2",
  null
  
)

export default component.exports